import script from "./ProjectTaskIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTaskIndex.vue?vue&type=script&setup=true&lang=js"

import "./ProjectTaskIndex.vue?vue&type=style&index=0&id=438f9d52&lang=css"
import "./ProjectTaskIndex.vue?vue&type=style&index=1&id=438f9d52&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-438f9d52"]])

export default __exports__